webpackJsonp([20],{

/***/ 1695:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _component_loader = __webpack_require__(102);

var _component_loader2 = _interopRequireDefault(_component_loader);

var _page_colors = __webpack_require__(663);

var _page_colors2 = _interopRequireDefault(_page_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(79);

__webpack_require__(666);

/**
 * Components related to Availability Showcase
 */

window.pageColors = new _page_colors2.default(window.pageColorData);

(0, _component_loader2.default)({
  HistoryIndex: __webpack_require__(1696),
  UptimeCalendar: __webpack_require__(1699)
});

/***/ }),

/***/ 1696:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _querier = __webpack_require__(214);

var _querier2 = _interopRequireDefault(_querier);

var _classnames = __webpack_require__(20);

var _classnames2 = _interopRequireDefault(_classnames);

var _items_selector = __webpack_require__(170);

var _items_selector2 = _interopRequireDefault(_items_selector);

var _incident_history = __webpack_require__(1697);

var _incident_history2 = _interopRequireDefault(_incident_history);

var _history_paginator = __webpack_require__(797);

var _history_paginator2 = _interopRequireDefault(_history_paginator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HistoryIndex = function (_React$Component) {
  _inherits(HistoryIndex, _React$Component);

  function HistoryIndex(props) {
    _classCallCheck(this, HistoryIndex);

    var _this = _possibleConstructorReturn(this, (HistoryIndex.__proto__ || Object.getPrototypeOf(HistoryIndex)).call(this, props));

    _this.state = {
      components: props.components,
      componentFilter: props.component_filter,
      filterComponentIds: [],
      months: props.months,
      showComponentFilter: props.show_component_filter,
      showItemsSelector: false
    };
    return _this;
  }

  _createClass(HistoryIndex, [{
    key: '_toggleComponentSelector',
    value: function _toggleComponentSelector() {
      this.setState({ showItemsSelector: !this.state.showItemsSelector });
    }
  }, {
    key: '_changeComponent',
    value: function _changeComponent(items) {
      var _this2 = this;

      var ids = [];
      items.forEach(function (item) {
        if (item.selected) {
          ids.push(item.id);
        }
        if (item.children.length > 0) {
          item.children.forEach(function (child) {
            if (child.selected) {
              ids.push(child.id);
            }
          });
        }
      });

      _querier2.default.fetch({ filter: ids.join(',') }, { merge: true }).then(function (data) {
        _this2.setState({
          components: data.components,
          componentFilter: data.component_filter,
          months: data.months
        });
      });
    }
  }, {
    key: '_renderComponentSelector',
    value: function _renderComponentSelector() {
      var preselectedItemIds = this.state.componentFilter || [];

      return _react2.default.createElement(_items_selector2.default, {
        items: this.props.components,
        className: 'component-items-selector',
        showFooter: false,
        onClose: this._toggleComponentSelector.bind(this),
        onToggle: this._changeComponent.bind(this),
        preselectedItemIds: preselectedItemIds });
    }
  }, {
    key: '_renderComponentSelectorButton',
    value: function _renderComponentSelectorButton() {
      if (this.state.showComponentFilter) {
        return _react2.default.createElement(
          'div',
          { className: 'component-selector' },
          _react2.default.createElement(
            'span',
            { className: (0, _classnames2.default)('show-filter', 'color-secondary', 'border-color', { open: this.state.showItemsSelector }), onClick: this._toggleComponentSelector.bind(this) },
            'Filter Components'
          ),
          this.state.showItemsSelector ? this._renderComponentSelector() : ''
        );
      }
    }
  }, {
    key: '_handlePagination',
    value: function _handlePagination(responseData) {
      this.setState({
        components: responseData.components,
        componentFilter: responseData.component_filter,
        months: responseData.months
      });
    }
  }, {
    key: '_renderMonths',
    value: function _renderMonths() {
      return this.state.months.map(function (month) {
        return _react2.default.createElement(
          'div',
          { className: 'month', key: '' + month.name + month.year },
          _react2.default.createElement(
            'h4',
            { className: 'month-title font-largest border-color' },
            month.name,
            '\xA0',
            _react2.default.createElement(
              'var',
              { 'data-var': 'year' },
              month.year
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'month-content' },
            _react2.default.createElement(_incident_history2.default, { incidents: month.incidents })
          )
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var startDateMonth = this.state.months[2].name;
      var startDateYear = this.state.months[2].year;
      var endDateMonth = this.state.months[0].name;
      var endDateYear = this.state.months[0].year;

      return _react2.default.createElement(
        'div',
        { className: 'history-backpage' },
        _react2.default.createElement(
          'div',
          { className: 'history-header' },
          this._renderComponentSelectorButton(),
          _react2.default.createElement(_history_paginator2.default, { startDateMonth: startDateMonth, startDateYear: startDateYear, endDateMonth: endDateMonth, endDateYear: endDateYear, responseHandler: this._handlePagination.bind(this) })
        ),
        _react2.default.createElement(
          'div',
          { className: 'months-container' },
          this._renderMonths()
        )
      );
    }
  }]);

  return HistoryIndex;
}(_react2.default.Component);

HistoryIndex.propTypes = {
  components: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
  component_filter: _propTypes2.default.array,
  months: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
  show_component_filter: _propTypes2.default.bool.isRequired
};

exports.default = HistoryIndex;

/***/ }),

/***/ 1697:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Incident = __webpack_require__(1698);

var IncidentHistory = function (_React$Component) {
  _inherits(IncidentHistory, _React$Component);

  function IncidentHistory(props) {
    _classCallCheck(this, IncidentHistory);

    var _this = _possibleConstructorReturn(this, (IncidentHistory.__proto__ || Object.getPrototypeOf(IncidentHistory)).call(this, props));

    _this.state = { expanded: false };
    return _this;
  }

  _createClass(IncidentHistory, [{
    key: '_toggleIncidents',
    value: function _toggleIncidents() {
      this.setState({ expanded: !this.state.expanded });
    }
  }, {
    key: '_buttonText',
    value: function _buttonText() {
      if (this.state.expanded) {
        return _react2.default.createElement(
          'span',
          null,
          '- Collapse Incidents'
        );
      } else {
        return _react2.default.createElement(
          'span',
          null,
          '+ Show All ',
          _react2.default.createElement(
            'var',
            null,
            this.props.incidents.length
          ),
          ' Incidents'
        );
      }
    }
  }, {
    key: '_displayToggler',
    value: function _displayToggler() {
      return _react2.default.createElement(
        'div',
        { className: 'expand-incidents font-small border-color color-secondary', onClick: this._toggleIncidents.bind(this) },
        this._buttonText()
      );
    }
  }, {
    key: '_renderIncidents',
    value: function _renderIncidents() {
      if (this.state.expanded) {
        return this.props.incidents.map(function (incident) {
          return _react2.default.createElement(Incident, { key: incident.code, incident: incident });
        });
      } else {
        return this.props.incidents.slice(0, 3).map(function (incident) {
          return _react2.default.createElement(Incident, { key: incident.code, incident: incident });
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'incident-history' },
        _react2.default.createElement(
          'div',
          { className: 'incident-list' },
          this.props.incidents.length === 0 ? _react2.default.createElement(
            'span',
            { className: 'small' },
            'No incidents reported for this month.'
          ) : this._renderIncidents()
        ),
        this.props.incidents.length > 3 ? this._displayToggler() : null
      );
    }
  }]);

  return IncidentHistory;
}(_react2.default.Component);

IncidentHistory.propTypes = {
  incidents: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired
};

module.exports = IncidentHistory;

/***/ }),

/***/ 1698:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _sanitizeHtml = __webpack_require__(345);

var _sanitizeHtml2 = _interopRequireDefault(_sanitizeHtml);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Incident = function (_React$Component) {
  _inherits(Incident, _React$Component);

  function Incident() {
    _classCallCheck(this, Incident);

    return _possibleConstructorReturn(this, (Incident.__proto__ || Object.getPrototypeOf(Incident)).apply(this, arguments));
  }

  _createClass(Incident, [{
    key: '_renderIncidentMessage',
    value: function _renderIncidentMessage() {
      return { __html: (0, _sanitizeHtml2.default)(this.props.incident.message) };
    }
  }, {
    key: '_renderIncidentTimestamp',
    value: function _renderIncidentTimestamp() {
      return { __html: this.props.incident.timestamp };
    }
  }, {
    key: 'render',
    value: function render() {
      var linkClasses = 'impact-' + this.props.incident.impact + ' incident-title font-large';
      var path = Routes.incident_url(this.props.incident.code);

      return _react2.default.createElement(
        'div',
        { className: 'incident-data incident-container' },
        _react2.default.createElement(
          'a',
          { href: path, className: linkClasses },
          this.props.incident.name
        ),
        _react2.default.createElement('div', { className: 'message incident-body color-primary', dangerouslySetInnerHTML: this._renderIncidentMessage() }),
        _react2.default.createElement('div', { className: 'secondary font-small color-secondary', dangerouslySetInnerHTML: this._renderIncidentTimestamp() })
      );
    }
  }]);

  return Incident;
}(_react2.default.Component);

Incident.propTypes = {
  incident: _propTypes2.default.object.isRequired
};

module.exports = Incident;

/***/ }),

/***/ 1699:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(3);

var _moment2 = _interopRequireDefault(_moment);

var _select_input = __webpack_require__(143);

var _select_input2 = _interopRequireDefault(_select_input);

var _calendar_day = __webpack_require__(1700);

var _calendar_day2 = _interopRequireDefault(_calendar_day);

var _querier = __webpack_require__(214);

var _querier2 = _interopRequireDefault(_querier);

var _history_paginator = __webpack_require__(797);

var _history_paginator2 = _interopRequireDefault(_history_paginator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Month = function Month(props) {
  // This fun thing takes the float to a string and trims the first two decimals. Necessary to avoid rounding 99.9999 up to 100.00.
  var uptimePercentage = (props.month.uptime_percentage * 100.00).toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
  return _react2.default.createElement(
    'div',
    { className: 'calendar-month' },
    _react2.default.createElement(
      'div',
      { className: 'month-header' },
      _react2.default.createElement(
        'h6',
        { className: 'month-name' },
        props.month.name,
        ' ',
        _react2.default.createElement(
          'var',
          { 'data-var': 'year' },
          props.month.year
        )
      ),
      _react2.default.createElement(
        'small',
        { className: 'month-uptime' },
        uptimePercentage,
        '%'
      )
    ),
    _react2.default.createElement(Calendar, { month: props.month })
  );
};

var Calendar = function Calendar(props) {
  var leftPadding = Array(props.month.start_offset).fill().map(function (_, i) {
    return _react2.default.createElement(_calendar_day2.default, { hidden: true, key: i + '-padding' });
  });

  var days = props.month.days.map(function (day, i) {
    return _react2.default.createElement(_calendar_day2.default, { key: i, color: day.color, tooltip: day.tooltip });
  });

  return _react2.default.createElement(
    'div',
    { className: 'days' },
    leftPadding.concat(days)
  );
};

var UptimeHistory = function (_Component) {
  _inherits(UptimeHistory, _Component);

  /*
   * Top level wrapper for the uptime calendar, takes an array of showcased components,
   * and an object of month data for display.
   *
   * @param {object} props
   * @param {object} components_select_list = array of component name/value for the select input
   * @param {object} months = object representing a month that contains a day count, starts_on day, and the component uptime for that month
   */

  function UptimeHistory(props) {
    _classCallCheck(this, UptimeHistory);

    var _this = _possibleConstructorReturn(this, (UptimeHistory.__proto__ || Object.getPrototypeOf(UptimeHistory)).call(this, props));

    _this.state = {
      component_select_list: props.component_select_list,
      component: props.component,
      months: props.months
    };

    _this._changeComponent = _this._changeComponent.bind(_this);
    _this._handlePagination = _this._handlePagination.bind(_this);
    return _this;
  }

  _createClass(UptimeHistory, [{
    key: '_drawMonths',
    value: function _drawMonths() {
      return this.state.months.map(function (month) {
        return _react2.default.createElement(Month, {
          key: month.name,
          month: month
        });
      });
    }
  }, {
    key: '_changeComponent',
    value: function _changeComponent(event) {
      var _this2 = this;

      var componentCode = event.target.options[event.target.selectedIndex].value;
      var path = '/uptime/' + componentCode;
      _querier2.default.fetch({}, { path: path, merge: true }).then(function (data) {
        _this2.setState({
          component_select_list: data.component_select_list,
          component: data.component,
          months: data.months
        });
      });
    }
  }, {
    key: '_handlePagination',
    value: function _handlePagination(data) {
      this.setState({
        component_select_list: data.component_select_list,
        component: data.component,
        months: data.months
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var startDateMonth = this.state.months[0].name;
      var startDateYear = this.state.months[0].year;
      var endDateMonth = this.state.months[2].name;
      var endDateYear = this.state.months[2].year;

      return _react2.default.createElement(
        'div',
        { className: 'uptime-calendar' },
        _react2.default.createElement(
          'div',
          { className: 'uptime-header' },
          _react2.default.createElement(
            'div',
            { className: 'component-selector' },
            _react2.default.createElement(_select_input2.default, {
              name: 'component',
              defaultValue: this.state.component.id,
              options: this.state.component_select_list,
              onChange: this._changeComponent })
          ),
          _react2.default.createElement(_history_paginator2.default, { startDateMonth: startDateMonth, startDateYear: startDateYear, endDateMonth: endDateMonth, endDateYear: endDateYear, responseHandler: this._handlePagination })
        ),
        _react2.default.createElement(
          'div',
          { className: 'uptime-calendar-display' },
          this._drawMonths()
        )
      );
    }
  }]);

  return UptimeHistory;
}(_react.Component);

Month.propTypes = {
  month: _propTypes2.default.object.isRequired
};

Calendar.propTypes = {
  month: _propTypes2.default.object.isRequired
};

UptimeHistory.propTypes = {
  component_select_list: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
  component: _propTypes2.default.object.isRequired,
  months: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired
};

exports.default = UptimeHistory;

/***/ }),

/***/ 1700:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FUTURE_DAY_COLOR = '#EAEAEA';

var CalendarDay = function (_Component) {
  _inherits(CalendarDay, _Component);

  function CalendarDay() {
    _classCallCheck(this, CalendarDay);

    return _possibleConstructorReturn(this, (CalendarDay.__proto__ || Object.getPrototypeOf(CalendarDay)).apply(this, arguments));
  }

  _createClass(CalendarDay, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.tooltipster && this._tooltip()) {
        this._initializeTooltip();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.tooltipster && this._tooltip()) {
        this.tooltipster.content(this._tooltip());
      } else if (!this.tooltipster && this._tooltip()) {
        this._initializeTooltip();
      } else if (this.tooltipster) {
        this.tooltipster.destroy();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.tooltipster) {
        this.tooltipster.destroy();
      }
    }
  }, {
    key: '_initializeTooltip',
    value: function _initializeTooltip() {
      $(this.svg).tooltipster({
        animationDuration: 100,
        contentAsHTML: true,
        delay: 100,
        theme: 'tooltipster-borderless',
        functionInit: function functionInit(instance, helper) {
          var $origin = $(helper.origin);
          var dataOptions = $origin.attr('data-tooltip-config');
          if (dataOptions) {
            dataOptions = JSON.parse(dataOptions);
            $.each(dataOptions, function (name, option) {
              instance.option(name, option);
            });
          }
        }
      });
      this.tooltipster = $(this.svg).tooltipster('instance');
    }
  }, {
    key: '_fill',
    value: function _fill() {
      if (this.props.color) {
        return this.props.color;
      }
      return FUTURE_DAY_COLOR;
    }
  }, {
    key: '_tooltip',
    value: function _tooltip() {
      return this.props.tooltip;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'svg',
        { className: 'day', width: '32', height: '32', xmlns: 'http://www.w3.org/2000/svg', ref: function ref(el) {
            return _this2.svg = el;
          }, title: this._tooltip() },
        _react2.default.createElement('rect', { className: this.props.hidden ? 'hide' : null, width: '32', height: '32', fill: this._fill() })
      );
    }
  }]);

  return CalendarDay;
}(_react.Component);

CalendarDay.propTypes = {
  hidden: _propTypes2.default.bool,
  tooltip: _propTypes2.default.string,
  color: _propTypes2.default.string
};

exports.default = CalendarDay;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),

/***/ 797:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(20);

var _classnames2 = _interopRequireDefault(_classnames);

var _querier = __webpack_require__(214);

var _querier2 = _interopRequireDefault(_querier);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
 * A shared paginator component for incidents and uptime history.
 *
 * @param {func} responseHandler = callback function for the pagination action
 * @param {string} startDate = label for the paginator start date
 * @param {string} endDate = label for the paginator end date
 */
var HistoryPaginator = function (_React$Component) {
  _inherits(HistoryPaginator, _React$Component);

  function HistoryPaginator(props) {
    _classCallCheck(this, HistoryPaginator);

    var _this = _possibleConstructorReturn(this, (HistoryPaginator.__proto__ || Object.getPrototypeOf(HistoryPaginator)).call(this, props));

    _this.state = {
      pageNumber: parseInt(_querier2.default.get().page || 1, 10)
    };
    _this._pageForward = _this._pageForward.bind(_this);
    _this._pageBack = _this._pageBack.bind(_this);
    _this._responseHandler = props.responseHandler;
    return _this;
  }

  _createClass(HistoryPaginator, [{
    key: '_canPageBack',
    value: function _canPageBack() {
      return this.state.pageNumber < 40;
    }
  }, {
    key: '_canPageForward',
    value: function _canPageForward() {
      return this.state.pageNumber > 1;
    }
  }, {
    key: '_pageBack',
    value: function _pageBack(event) {
      var _this2 = this;

      event.preventDefault();
      if (this._canPageBack()) {
        this.state.pageNumber += 1;
        _querier2.default.fetch({ page: this.state.pageNumber }, { merge: true }).then(function (responseData) {
          _this2._responseHandler(responseData);
        });
      }
    }
  }, {
    key: '_pageForward',
    value: function _pageForward(event) {
      var _this3 = this;

      event.preventDefault();
      if (this._canPageForward()) {
        this.state.pageNumber -= 1;
        _querier2.default.fetch({ page: this.state.pageNumber }, { merge: true }).then(function (responseData) {
          _this3._responseHandler(responseData);
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var backClass = (0, _classnames2.default)('previous-page border-color color-secondary', { disabled: !this._canPageBack() });
      var fwdClass = (0, _classnames2.default)('next-page border-color color-secondary', { disabled: !this._canPageForward() });

      return _react2.default.createElement(
        'div',
        { className: 'pagination-container' },
        _react2.default.createElement(
          'div',
          { className: 'pagination' },
          _react2.default.createElement(
            'a',
            { href: '#back', className: backClass, onClick: this._pageBack },
            _react2.default.createElement('i', { className: 'left-arrow' })
          ),
          _react2.default.createElement(
            'span',
            { className: 'current' },
            _react2.default.createElement(
              'span',
              null,
              this.props.startDateMonth
            ),
            _react2.default.createElement(
              'var',
              { 'data-var': 'year' },
              ' ',
              this.props.startDateYear
            ),
            ' to ',
            _react2.default.createElement(
              'span',
              null,
              this.props.endDateMonth
            ),
            _react2.default.createElement(
              'var',
              { 'data-var': 'year' },
              ' ',
              this.props.endDateYear
            )
          ),
          _react2.default.createElement(
            'a',
            { href: '#forward', className: fwdClass, onClick: this._pageForward },
            _react2.default.createElement('i', { className: 'right-arrow' })
          )
        )
      );
    }
  }]);

  return HistoryPaginator;
}(_react2.default.Component);

HistoryPaginator.propTypes = {
  startDateMonth: _propTypes2.default.string.isRequired,
  startDateYear: _propTypes2.default.number.isRequired,
  endDateMonth: _propTypes2.default.string.isRequired,
  endDateYear: _propTypes2.default.number.isRequired,
  responseHandler: _propTypes2.default.func.isRequired
};

module.exports = HistoryPaginator;

/***/ })

},[1695]);


// WEBPACK FOOTER //
// status-3962c3565ddb37409fc4.js